import { render, staticRenderFns } from "./ProposedHolder.vue?vue&type=template&id=b9e5b538"
import script from "./ProposedHolder.vue?vue&type=script&lang=js"
export * from "./ProposedHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports